import BankTransactionStatementPairTableView from "@pages/banks/bankTransactions/BankTransactionStatementPairTableView";
import i18next from "i18next";
import { createBindingContext } from "@odata/BindingContext";
import { NEW_ITEM_DETAIL } from "../../../constants";
import { DocumentTypeCode } from "@odata/GeneratedEnums";
import { EntitySetName } from "@odata/GeneratedEntityTypes";

export class LoanTransactionStatementPairTableView extends BankTransactionStatementPairTableView {
    type = DocumentTypeCode.LoanTransaction;

    getHeaderData = () => {
        const data = super.getHeaderData();
        data[0].label = i18next.t("Banks:LoanTransactions.DateBankTransaction");

        return data.slice(0, 4);
    }

    getTitle = () => {
        return this.props.rootStorage.t("Banks:LoanTransactions.PairTitle");
    };

    getSecondaryTitle = () => {
        return this.props.rootStorage.t("Banks:LoanTransactions.FromStatement");
    }

    handleAddClick = () => {
        const bc = createBindingContext(EntitySetName.LoanStatements, this.props.rootStorage.oData.metadata).addKey(NEW_ITEM_DETAIL, true);
        this.props.onRowSelect?.(bc, null, null, {
            hideTransactions: true
        });
    };

}
